import AccessLogDataGrid from './AccessLogDataGrid';

export default AccessLogDataGrid;
